<div class="product-list">

  @if (showTitle) {
    <div class="product-list-name"
    >{{ "CART.TITLE_PRODUCTS" | transloco }}</div>
  }

  <!-- choix produits -->
  @for (category of displayedCartProductsByCategory; track trackByCategoryName($index, category); let isLast = $last) {
    <div @inOutAnimation
      [ngClass]="{'product-list-category': showCategory}">
      @if (showCategory) {
        <div class="product-list-category-title"
        >{{ category.categoryName }}</div>
      }
      @for (product of category.cartProducts; track trackByCartProductIdentity($index, product); let isLast = $last) {
        <div @inOutAnimation
          class="product-list-item">
          <app-cart-product-tile [cartProduct]="product"
            [currencyCode]="currencyCode"
            [showZeroPrices]="showZeroPrices"
            [showDivider]="showDivider && !isLast"
          (editCartProductClick)="onEditCartProductClick($event)"></app-cart-product-tile>
        </div>
      }
      @if (showCategory && !isLast) {
        <mat-divider class="cart-category-divider"
        ></mat-divider>
      }
    </div>
  }

</div>
